export default {
  install: function (Vue) {
    Vue.prototype.$auth_helper = {
      isShowFeature(store, org_id, feature_name) {
        let is_show = false
        let target_feature = store.getters.memberQuota[org_id].quotaVo.filter((item) => {
          return item.function === feature_name
        })
        if (target_feature && target_feature.limit >= 1) {
          is_show = true
        } else {
          if (store.getters.loggedInfo.is_beta_user === 1) {
            is_show = true
          }
        }

        return is_show
      },
    }
  },
}
